<template>
<SessionTimeoutDialog
      v-model="showDialog"
      @confirmLogout="handleLogout"
    />
  <ForceLogoutForDeactivateUserDialog
      v-model="showDialog2"
      @confirmLogout="handleLogout"
    />
  <router-view />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import SessionTimeoutDialog from './components/AUTH/SessionTimeoutDialog.vue'
import ForceLogoutForDeactivateUserDialog from './components/AUTH/ForceLogoutForDeactivateUserDialog.vue'
import { useRouter } from 'vue-router'

const showDialog = ref(false)
const showDialog2 = ref(false)
const router = useRouter()

onMounted(() => {
  window.addEventListener('session-timeout', () => {
    showDialog.value = true
  })

  window.addEventListener('force-logout', () => {
    showDialog2.value = true
  })
})

function handleLogout() {
  localStorage.removeItem('token')
  router.push('/login')
}
</script>

<style>
  @import "styles/font.scss";
  @import "styles/main.scss";
</style>
